module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x1.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x1.png
// module id = 78
// module chunks = 3